import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PagesProvider } from '../../../providers/pages-provider';
import { GirisPage } from '../../giris/giris';


@Component({
  selector: 'page-teknik-servis-ana-sayfa',
  templateUrl: 'teknik-servis-ana-sayfa.html',
})
export class TeknikServisAnaSayfaPage {
menuler=[];
gunSonu=false;
  constructor(public navCtrl: NavController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.MenuleriGoruntule();
   }
 
 
   menuItemClick(item) {
    
     var pagesProvider = new PagesProvider();
     var componentType = typeof item.PAGE_COMPONENT;
     var component;
     if (componentType === "string")
       component = pagesProvider.components[item.PAGE_COMPONENT];
     else
       component = item.PAGE_COMPONENT;
     if (component == GirisPage) {
     //  this.ortak.storeagePersonelCikar();
     }
     this.navCtrl.push(component);
   }
   MenuleriGoruntule() {
     var pagesProvider = new PagesProvider();
     pagesProvider.menuler().then(a => {
       var sonuc = <any>a;
       
         this.menuler = sonuc.TEKNIK_MENU;
       })
     
   }
 

}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/teknik-servis-ana-sayfa/teknik-servis-ana-sayfa.ts